import { HttpErrorResponse } from '@angular/common/http';
import { AccountInfo, AuthenticationResult } from '@azure/msal-browser';
import { UserDto } from 'src/app/modules/login/services/user-api.service';
import { AuthType } from 'src/app/modules/login/auth-green.service';
import { Permission } from 'src/app/modules/permissions/models/permissions.model';
import { ConfigurationDto } from 'src/app/shared/services/configuration-api.service';

export interface AppState {
  user: UserDto | null;
  greenAuthUser: any | null;
  authType: AuthType | null;
  authCode: string | null;
  licenseExpired: boolean | null;
  loginError: HttpErrorResponse | null;
  onlyEmailAuthOption: boolean | null;
  loginning: boolean;
  inviting: boolean;
  invitingFail: boolean;
  accessRestricted: boolean;
  gettingUserDetails: boolean;
  savingUserDetails: boolean;
  currentUserPermissions: Permission[];
  gettingCurrentUserPermissions: boolean;
  currentUserPermissionsLoaded: boolean;
  isLoggedIn: boolean;
  authenticationResult: AuthenticationResult | null;
  authenticatedAccount: AccountInfo | null;

  clauseNameToBeFiltered: string | null;

  configuration: ConfigurationDto | null;
}

export const initialAppState: AppState = {
  user: null,
  greenAuthUser: null,
  authType: null,
  authCode: null,
  licenseExpired: null,
  loginError: null,
  onlyEmailAuthOption: null,
  loginning: false,
  inviting: false,
  invitingFail: false,
  accessRestricted: false,
  gettingUserDetails: false,
  savingUserDetails: false,
  currentUserPermissions: [],
  gettingCurrentUserPermissions: false,
  currentUserPermissionsLoaded: false,
  isLoggedIn: false,
  authenticationResult: null,
  authenticatedAccount: null,

  clauseNameToBeFiltered: null,

  configuration: null,
};
